import React, { useEffect, useState, useRef, useMemo } from 'react'
import background from 'img/Summit.jpg'
import xtractLogo from 'img/xtract_logo.png'
import { xtractAPI } from 'actions/apiActions'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

const AuthView = ({ children }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const [clientLogoSrc, setClientLogoSrc] = useState(null)
  const setClientLogoSrcRef = useRef(0)

  useEffect(() => {
    // componentWillMount
    setClientLogoSrcRef.current = setClientLogoSrc
    const callbacks = {
      200: result => {
        setClientLogoSrcRef.current(result.data.data['client-logo'].image)
      },
      error: result => {
        setClientLogoSrcRef.current('')
      }
    }

    // there is an open issue for firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1280189 that when you make an api request
    // and then navigate away from the page before the api request completes, when the api request is canceled by the browser it
    // throws a general networkError rather than some sort of identifiable error. For us that means, if we are loading the 
    // client logo below and we do a redirect (during oauth launch) a network error will be thrown if the redirect happens before
    // the logo call completes which causes are generalErrorHandler to fire and briefly flash the network error modal. Until firefox
    // deals with this issue... we will just detect the /launch routes and skip loading the logo for those (the user shouldn't)
    // really be on the page long enough to see the logo anyway.
    if(!pathname.endsWith('/launch')) {
      dispatch(xtractAPI(
        'config/image/client-logo',
        'read',
        null,
        callbacks
      ))
    } else {
      setClientLogoSrcRef.current('')
    }

    return () => {
      // willUnmount
      setClientLogoSrcRef.current = () => null
    }
  }, [])

  return (
    <div
      className="login-background"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="login">
        <img
          src={xtractLogo}
          style={{ width: '428px', height: '177px' }}
          alt="Xtract Solutions logo"
        />
        <div className="login-controls">
          {children}
        </div>
        <div
          className="customer-logo-container"
          style={{ width: '470px', height: '200px' }}
        >
          {!clientLogoSrc || clientLogoSrc === ''
            ? null
            : (
            <img
              alt="client-logo"
              onError={e => (e.target.style.display = 'none')}
              src={clientLogoSrc}
            />
              )}
        </div>
      </div>
    </div>
  )
}
export default AuthView
